const NotificationTypes = {
    UPLOAD_FINISHED: "UPLOAD_FINISHED",
    UPLOAD_ERROR: "UPLOAD_ERROR",
    UPDATE_FINISHED: "UPDATE_FINISHED",
    UPDATE_ERROR: "UPDATE_ERROR"
  };
  
  export default NotificationTypes;